import { render, staticRenderFns } from "./TargetList.vue?vue&type=template&id=b18190da&scoped=true"
import script from "./TargetList.vue?vue&type=script&lang=js"
export * from "./TargetList.vue?vue&type=script&lang=js"
import style0 from "./TargetList.vue?vue&type=style&index=0&id=b18190da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18190da",
  null
  
)

export default component.exports